var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { EGDSCard } from '@egds/react-core/cards';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSText } from '@egds/react-core/text';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import * as React from 'react';
import { ClientLogger } from 'bernie-client';
import { ErrorBoundary } from 'bernie-view';
import { merge } from 'bernie-core';
import { performanceMetrics } from 'bernie-analytics';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { withLocalization } from '@shared-ui/localization-context';
import { CurrentHotelStore } from 'stores/current-hotel-store';
import { DateType } from 'constants/dates';
import { DateStepper } from 'components/infosite/rooms-and-rates/availability-wizard/internals/date-stepper';
import { SearchValidation } from 'components/infosite/rooms-and-rates/availability-wizard/internals/search-validation';
const logger = ClientLogger.getLoggerWithIdentifier('availabilityWizard.error');
const {
  withKeys
} = merge;
// @ts-ignore
export let AvailabilityWizard = class AvailabilityWizard extends React.Component {
  constructor(props) {
    super(props);
    const {
      l10n
    } = props;
    this.searchValidator = new SearchValidation(l10n.formatText, props.experiment);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      inputErrors: {},
      midnightBookingOffsetHours: 4,
      numDaysBookableInAdvance: 500
    };
  }
  handleChange(event, isTriggeredByStepper) {
    var _a;
    let target = event.target;
    if (!Array.isArray(target)) {
      target = [target];
    }
    const targetDictionary = {};
    target.forEach(searchChangeProp => {
      targetDictionary[searchChangeProp.name] = searchChangeProp.value;
    });
    const offerSearchData = withKeys(CurrentHotelStore.offerSearchKeys).merge({}, targetDictionary);
    (_a = this.props.currentHotel) === null || _a === void 0 ? void 0 : _a.setOfferData(offerSearchData);
    this.handleSubmit(isTriggeredByStepper);
  }
  logTracking(rfrr, linkName) {
    var _a;
    const {
      analytics
    } = this.props;
    if (analytics && typeof analytics.clickTracker === 'function') {
      (_a = this.props.analytics) === null || _a === void 0 ? void 0 : _a.clickTracker(rfrr, linkName, null, null)();
    }
  }
  handleSubmit(isTriggeredByStepper = false) {
    var _a;
    const {
      currentHotel,
      history
    } = this.props;
    const errorState = {
      inputErrors: {}
    };
    const offerSearchData = (_a = currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.offerSearchData) !== null && _a !== void 0 ? _a : {};
    const startDateError = currentHotel && this.searchValidator.startDate(offerSearchData);
    const endDateError = currentHotel && this.searchValidator.endDate(offerSearchData);
    const adultError = currentHotel && this.searchValidator.adults(offerSearchData);
    const childrenError = currentHotel && this.searchValidator.children(offerSearchData);
    if (startDateError || endDateError || adultError || childrenError) {
      errorState.inputErrors = {
        startDate: startDateError,
        endDate: endDateError,
        adults: adultError,
        children: childrenError
      };
    }
    if (this.hasInputErrors(errorState)) {
      if (!isTriggeredByStepper && history) {
        history.goBack();
      }
      const errorMessages = [];
      const errors = errorState.inputErrors;
      for (const i in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, i) && errors[i] !== undefined) {
          errorMessages.push(errors[i]);
        }
      }
      if (errorMessages.length > 0) {
        logger.logEvent(new SystemEvent(SystemEventLevel.WARN, 'SEARCH_FORM_HANDLE_SUBMIT'), JSON.stringify(errorMessages));
      }
    } else {
      performanceMetrics.reset();
      const {
        onUpdateResults
      } = this.props;
      if (onUpdateResults && typeof onUpdateResults === 'function') {
        if (isTriggeredByStepper) {
          onUpdateResults(undefined, currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.offerSearchData, false);
          this.logTracking('ChangeDatesStepper:Submit', 'Submitsearch using date stepper buttons');
        } else {
          onUpdateResults(undefined, currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.offerSearchData, true);
          this.logTracking('FORM.SUBMIT', 'Submit search form');
        }
      }
    }
    this.setState(errorState);
  }
  hasInputErrors(validationItems) {
    const temp = validationItems && validationItems;
    for (const key in temp.inputErrors) {
      if (temp.inputErrors[key] !== undefined) {
        return true;
      }
    }
  }
  render() {
    var _a, _b;
    const {
      currentHotel,
      l10n
    } = this.props;
    if (!currentHotel) return null;
    const {
      inputErrors,
      midnightBookingOffsetHours,
      numDaysBookableInAdvance
    } = this.state;
    const {
      formatText
    } = l10n;
    const {
      offerSearchData
    } = currentHotel;
    const startDate = (_a = offerSearchData === null || offerSearchData === void 0 ? void 0 : offerSearchData.startDate) !== null && _a !== void 0 ? _a : '';
    const endDate = (_b = offerSearchData === null || offerSearchData === void 0 ? void 0 : offerSearchData.endDate) !== null && _b !== void 0 ? _b : '';
    const stepperProps = {
      clickHandler: this.handleChange,
      endDate,
      startDate,
      invalid: inputErrors && inputErrors.startDate,
      midnightBookingOffsetHours,
      numDaysBookableInAdvance
    };
    return React.createElement(EGDSSpacing, {
      margin: {
        block: 'three'
      }
    }, React.createElement("div", null, React.createElement(ErrorBoundary, {
      label: "hotel.information.rooms.availabilityWizardStepper"
    }, React.createElement(EGDSCard, null, React.createElement(EGDSText, {
      align: "center"
    }, React.createElement(EGDSLayoutFlex, {
      direction: "row",
      justifyContent: "space-between"
    }, React.createElement(EGDSLayoutFlexItem, {
      minWidth: "half_width"
    }, React.createElement(EGDSLayoutFlex, {
      direction: "column",
      justifyContent: "space-between"
    }, React.createElement(DateStepper, Object.assign({
      buttonText: formatText('hotels.infosite.searchForm.availabilityButton.label')
    }, stepperProps, {
      dateType: DateType.CHECK_IN
    })))), React.createElement(EGDSLayoutFlexItem, {
      minWidth: "half_width"
    }, React.createElement(EGDSLayoutFlex, {
      direction: "column",
      justifyContent: "space-between"
    }, React.createElement(DateStepper, Object.assign({
      buttonText: formatText('hotels.infosite.searchForm.availabilityButton.label')
    }, stepperProps, {
      dateType: DateType.CHECK_OUT
    }))))))))));
  }
};
AvailabilityWizard = __decorate([withRouter, withLocalization, inject('currentHotel', 'analytics', 'experiment'), observer], AvailabilityWizard);